var _dec, _dec2, _dec3, _class, _descriptor, _descriptor2, _descriptor3, _class2;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import { reads } from '@ember/object/computed';
import { belongsTo } from '@ember-data/model';
import ItemsV3Base from '@square/dashboard-items-data/models/items-v3-base';
// these two imports are causing failures when running the prepublish step in frontend/@dashboard/sales-tax-shared/package.json step in kochiku:
// e.g. "'Item' is declared but its value is never read.""
// The below ts-ignore comments are safe, because these types are in fact used.
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
let ItemFeeMembership = (_dec = belongsTo('item', {
  async: false
}), _dec2 = belongsTo('fee', {
  async: false
}), _dec3 = reads('version'), (_class = (_class2 = class ItemFeeMembership extends ItemsV3Base {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "item", _descriptor, this);
    _initializerDefineProperty(this, "fee", _descriptor2, this);
    _initializerDefineProperty(this, "relationshipTrackerVersion", _descriptor3, this);
  }
  static catalogType() {
    return 'ITEM_FEE_MEMBERSHIP';
  }
}, _defineProperty(_class2, "_modelNameForMigration", 'item-fee-membership'), _class2), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "item", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "fee", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "relationshipTrackerVersion", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class));
export default ItemFeeMembership;